import { connect } from "react-redux";
import dayjs from "dayjs";
import List from "../../../common/list";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import { AccessScopeConstants } from "../../../../constants";
import * as ListCellRenders from "../../../common/list/ListCellRenders";

const AudienceAssignmentList = ({
  assignments,
  id,
  user,
  onDeleteAssignmentAction,
}) => {
  const { role } = user || {};
  const canDelete = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.ContentAccess,
    AccessScopeConstants.UpdateScope
  );

  return (
    <List
      data={assignments}
      pagination={false}
      selectionMode=""
      totalRecords={assignments.length || 0}
      columns={[
        {
          field: "learningPathwayName",
          header: "learning_program_name",
        },
        {
          field: "startDate",
          header: "start_date",
          body: (rowData) => {
            if (rowData?.isDateFlexible) {
              return "-";
            } else {
              return (
                dayjs
                  .utc(rowData.startDate)
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format("DD MMM YYYY") || "-"
              );
            }
          },
        },
        {
          field: "endDate",
          header: "end_date",
          body: (rowData) => {
            if (rowData?.isDateFlexible) {
              return "-";
            } else {
              return (
                (rowData.endDate &&
                  dayjs
                    .utc(rowData.endDate)
                    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                    .format("DD MMM YYYY")) ||
                "-"
              );
            }
          },
        },
        {
          field: "relativeEndInDays",
          header: "relative_end_days",
          sortable: false,
        },
        {
          field: "actions",
          headerIcon: "pi-cog",
          align: "center",
          body: ListCellRenders.OtherActions([
            {
              label: "delete",
              icon: "pi-trash",
              isAllowed: canDelete,
              action: (data) => onDeleteAssignmentAction(data),
            },
          ]),
        },
      ]}
    />
  );
};

const mapStateToProps = (state) => ({
  assignments: state.audiences.record?.assignments || [],
});

export default connect(mapStateToProps)(AudienceAssignmentList);
